// Dependencies
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ComponentLoader from "../../components/Spinner/ComponentLoader";

// Project imports
import { useCurrentRoute, useReactRouterCompat } from "./hooks";

export const ReactRouterCompatibilityLoader = () => {
	return (
		<div className="fixed left-0 top-0 z-[9999] flex h-full w-full items-center justify-center">
			<ComponentLoader />
		</div>
	);
};

/**
 * A react component that invokes the compatibility hook used to sync the url data
 * with the redux store for compatibility reasons. When transitioning to a template
 * page, it shows a spinner instead of rendering children.
 */
export const ReactRouterCompatibility = ({ children }: { children: React.ReactNode }) => {
	const isLoading = useReactRouterCompat();

	if (isLoading) {
		return <ReactRouterCompatibilityLoader />;
	}

	return <React.Fragment>{children}</React.Fragment>;
};

/**
 * a higher order component that wraps a component and passes the current
 * react router location, navigate, and params to the wrapped component.
 * @returns React.ComponentType
 */
export const withRouter = (Component: React.ComponentType<any>) => {
	const WithRouter = (props: any) => {
		const params = useParams();
		const location = useLocation();
		const navigate = useNavigate();
		const currentRoute = useCurrentRoute();

		return (
			<Component {...props} location={location} navigate={navigate} params={params} currentRoute={currentRoute} />
		);
	};

	return WithRouter;
};
